<main class="main-wrap-ng">
  <div class="content-blk">
    <div class="container">

      <div *ngIf="!showAppTour">
        <small class="pull-right app-help-text" (click)="changeAppMode(true)">
          <i class="fa fa-circle pulsate" aria-hidden="true"></i>
          &nbsp;
          How it works?
        </small>

        <h5 class="page-title">
          Dashboard
        </h5>

        <div class="alert alert-danger" *ngIf="!HasW9Details" role="alert" style="padding:5px 7px">
          <i class="fa fa-warning"></i>
          <small>
            Please fill W9 form details to make your stores online and receive commission, make sure to have paypal account updated too.
            <a [routerLink]="[ '/store/W9Form']" class="btn btn-sm">
              Submit W9
            </a>
          </small>          
        </div>
        <div class="alert alert-danger" *ngIf="HasW9Details && ShowofflineStore>0" role="alert" style="padding:5px 7px">
          <small>
            One or more stores are offline.<a [routerLink]="[ '/store/list']" class="btn btn-sm">
              Click to View
            </a>
          </small>
        </div>

        <!-- Subscription Info Card -->
        <div class="subscription-card" *ngIf="subscriptionInfo">
          <div class="subscription-header">
            <div class="subscription-title">
              <i class="fa fa-diamond"></i>
              Your Subscription
            </div>
            <span class="subscription-badge" [ngClass]="{'badge-active': subscriptionInfo.IsActive, 'badge-inactive': !subscriptionInfo.IsActive}">
              {{ subscriptionInfo.IsActive ? 'Active' : 'Inactive' }}
            </span>
          </div>
          <div class="subscription-body">
            <div class="subscription-plan-row">
              <div class="plan-name">{{ subscriptionInfo.PlanName }}</div>
              <div class="plan-price">${{ subscriptionInfo.Price }} <small>/ {{ subscriptionInfo.Duration }}</small></div>
            </div>
            <div class="subscription-details-row">
              <div class="detail-item" *ngIf="subscriptionInfo.ExpiryDate">
                <span class="detail-label">Expires</span>
                <span class="detail-value" [ngClass]="{'expiry-warning': fn_GetDaysUntilExpiry() !== null && fn_GetDaysUntilExpiry() <= 7}">
                  {{ subscriptionInfo.ExpiryDate | date:'mediumDate' }}
                  <small *ngIf="fn_GetDaysUntilExpiry() !== null && fn_GetDaysUntilExpiry() > 0">({{ fn_GetDaysUntilExpiry() }} days left)</small>
                  <small *ngIf="fn_GetDaysUntilExpiry() !== null && fn_GetDaysUntilExpiry() <= 0" class="expiry-warning">(Expired)</small>
                </span>
              </div>
            </div>
            <div class="subscription-features" *ngIf="subscriptionInfo.Features && subscriptionInfo.Features.length > 0">
              <div class="features-title">Plan Features</div>
              <div class="features-list">
                <div class="feature-item" *ngFor="let feature of subscriptionInfo.Features">
                  <i class="fa" [ngClass]="{'fa-check-circle feature-enabled': feature.Type === 'boolean' && feature.Value === 'true', 'fa-times-circle feature-disabled': feature.Type === 'boolean' && feature.Value !== 'true', 'fa-info-circle feature-value': feature.Type !== 'boolean'}"></i>
                  <span class="feature-name">{{ feature.FeatureName }}</span>
                  <span class="feature-val" *ngIf="feature.Type !== 'boolean'">{{ feature.Value }}</span>
                </div>
              </div>
            </div>
            <div class="subscription-addons" *ngIf="subscriptionInfo.AddOnServices && subscriptionInfo.AddOnServices.length > 0">
              <div class="addons-title">Add-On Services</div>
              <div class="addons-list">
                <div class="addon-item" *ngFor="let addon of subscriptionInfo.AddOnServices">
                  <i class="fa fa-plus-circle"></i>
                  <span class="addon-name">{{ addon.ServiceName }}</span>
                  <span class="addon-price">${{ addon.Price }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="add-product-dashboard">
          Choose and start designing Product with unlimited combinations
          <span (click)="showAddProductWindow()">
            <i class="fa fa-window-restore" aria-hidden="true"></i>  Select & Design Now
          </span>
        </div>

        <div class="add-product-dashboard" style="margin-top: 15px;">
          Update decoration type tags for all customized products
          <span (click)="updateDecorationTypeTags()">
            <i class="fa fa-tags" aria-hidden="true"></i>  Update Decoration Tags
          </span>
        </div>

        <app-dashboard-count-sub-component color="ttl-od"
                                           [storeList]="storeList"
                                           [TotalNoOfPublishedProducts]="dashboardDivData.TotalNoOfPublishedProducts"
                                           [TotalNoOfStores]="dashboardDivData.TotalNoOfStores"
                                           labelClass="label-default"
                                           icon="shopping_cart">
        </app-dashboard-count-sub-component>


        <app-line-chart></app-line-chart>
      </div>


      <div *ngIf="showAppTour" class="appTourSection">
        <small class="pull-right app-help-text" (click)="changeAppMode(false)" *ngIf="storeList.length > 0">
          <i class="fa fa-circle pulsate" aria-hidden="true"></i>
          &nbsp;
          Go to Dashboard
        </small>
        <h5 class="page-title">
          How it works?
        </h5>
        <div class="add-product-dashboard">
          <div class="steps-app-info">
            <i class="fa fa-circle pulsate" aria-hidden="true"></i>
            &nbsp;
            <a [routerLink]="[ '/store/list']" class="anchor-dashboard">
              Store Gallery
            </a>
            &nbsp;
            With no experience in e-commerce,
            you can have an online store created within minutes.

            <div class="row margin-top-10">
              <div class="col-md-3" (click)="Row_1_Img='a'" [ngClass]="{'preview-on': Row_1_Img =='a'}">
                <figure class="figure">
                  <i class="fa fa-search-plus zoom-image" aria-hidden="true" title="Click To Zoom"></i>
                  <img src="assets/img/app-introduction/a.JPG" class="img-fluid figure-img rounded" />
                  <figcaption class="figure-caption">1. Create a store</figcaption>
                </figure>
              </div>
              <div class="col-md-3" (click)="Row_1_Img='b'" [ngClass]="{'preview-on': Row_1_Img =='b'}">
                <figure class="figure">
                  <i class="fa fa-search-plus zoom-image" aria-hidden="true" title="Click To Zoom"></i>
                  <img src="assets/img/app-introduction/b.JPG" class="img-fluid figure-img rounded" />
                  <figcaption class="figure-caption">2. Options to update, view, delete and customise store front</figcaption>
                </figure>
              </div>
              <div class="col-md-3" (click)="Row_1_Img='c'" [ngClass]="{'preview-on': Row_1_Img =='c'}">
                <figure class="figure">
                  <i class="fa fa-search-plus zoom-image" aria-hidden="true" title="Click To Zoom"></i>
                  <img src="assets/img/app-introduction/c.JPG" class="img-fluid figure-img rounded" />
                  <figcaption class="figure-caption">3. Customize the store front with unique components</figcaption>
                </figure>
              </div>
            </div>
            <div class="row" *ngIf="Row_1_Img!=null">
              <div class="col-md-12" (click)="Row_1_Img=null">
                <i class="fa fa-times remove-preview" aria-hidden="true"></i>
                <img src="assets/img/app-introduction/{{Row_1_Img}}.JPG" class="img-fluid figure-img rounded" />
              </div>
            </div>
          </div>
          <div class="steps-app-info">
            <i class="fa fa-circle pulsate" aria-hidden="true"></i>
            &nbsp;
            <span (click)="showAddProductWindow()">
              Select & Design
            </span>
            &nbsp;
            Choose and start designing Product with unlimited combinations.
            <div class="row margin-top-10">
              <div class="col-md-3" (click)="Row_2_Img='d'" [ngClass]="{'preview-on': Row_2_Img =='d'}">
                <figure class="figure">
                  <i class="fa fa-search-plus zoom-image" aria-hidden="true" title="Click To Zoom"></i>
                  <img src="assets/img/app-introduction/d.JPG" class="img-fluid figure-img rounded" />
                  <figcaption class="figure-caption">1. Choose a product for your brand</figcaption>
                </figure>
              </div>
              <div class="col-md-3" (click)="Row_2_Img='e'" [ngClass]="{'preview-on': Row_2_Img =='e'}">
                <figure class="figure">
                  <i class="fa fa-search-plus zoom-image" aria-hidden="true" title="Click To Zoom"></i>
                  <img src="assets/img/app-introduction/e.JPG" class="img-fluid figure-img rounded" />
                  <figcaption class="figure-caption">2. Design Product with unlimited combination and save your design</figcaption>
                </figure>
              </div>
              <div class="col-md-3" (click)="Row_2_Img='f'" [ngClass]="{'preview-on': Row_2_Img =='f'}">
                <figure class="figure">
                  <i class="fa fa-search-plus zoom-image" aria-hidden="true" title="Click To Zoom"></i>
                  <img src="assets/img/app-introduction/f.JPG" class="img-fluid figure-img rounded" />
                  <figcaption class="figure-caption">3. Select color variation of product to publish in store for users and add your commission</figcaption>
                </figure>
              </div>
              <div class="col-md-3" (click)="Row_2_Img='g'" [ngClass]="{'preview-on': Row_2_Img =='g'}">
                <figure class="figure">
                  <i class="fa fa-search-plus zoom-image" aria-hidden="true" title="Click To Zoom"></i>
                  <img src="assets/img/app-introduction/g.JPG" class="img-fluid figure-img rounded" />
                  <figcaption class="figure-caption">4. Publish product to the store and start receiving order on the fly.</figcaption>
                </figure>
              </div>
            </div>
            <div class="row" *ngIf="Row_2_Img!=null">
              <div class="col-md-12" (click)="Row_2_Img=null">
                <i class="fa fa-times remove-preview" aria-hidden="true"></i>
                <img src="assets/img/app-introduction/{{Row_2_Img}}.JPG" class="img-fluid figure-img rounded" />
              </div>
            </div>
          </div>
          <div class="steps-app-info">
            <i class="fa fa-circle pulsate" aria-hidden="true"></i>
            &nbsp;
            <a [routerLink]="[ '/store/customizedproducts']" class="anchor-dashboard">
              Products
            </a>
            &nbsp;
            Product library of your all customized products.
            <div class="row margin-top-10">
              <div class="col-md-3" (click)="Row_3_Img='h'" [ngClass]="{'preview-on': Row_3_Img =='h'}">
                <figure class="figure">
                  <i class="fa fa-search-plus zoom-image" aria-hidden="true" title="Click To Zoom"></i>
                  <img src="assets/img/app-introduction/h.JPG" class="img-fluid figure-img rounded" />
                  <figcaption class="figure-caption">1. View customized products listing, delete and preview product details or publish products to new stores</figcaption>
                </figure>
              </div>
            </div>
            <div class="row" *ngIf="Row_3_Img!=null">
              <div class="col-md-12" (click)="Row_3_Img=null">
                <i class="fa fa-times remove-preview" aria-hidden="true"></i>
                <img src="assets/img/app-introduction/{{Row_3_Img}}.JPG" class="img-fluid figure-img rounded" />
              </div>
            </div>
          </div>
          <div class="steps-app-info">
            <i class="fa fa-circle pulsate" aria-hidden="true"></i>
            &nbsp;
            <a [routerLink]="[ '/store/publishedproducts']" class="anchor-dashboard">
              Published Products
            </a>
            &nbsp;
            See published product, use filters to view store specific products.
            <div class="row margin-top-10">
              <div class="col-md-3" (click)="Row_4_Img='i'" [ngClass]="{'preview-on': Row_4_Img =='i'}">
                <figure class="figure">
                  <i class="fa fa-search-plus zoom-image" aria-hidden="true" title="Click To Zoom"></i>
                  <img src="assets/img/app-introduction/i.JPG" class="img-fluid figure-img rounded" />
                  <figcaption class="figure-caption">1. View published products listing, delete from store and update commision</figcaption>
                </figure>
              </div>
            </div>
            <div class="row" *ngIf="Row_4_Img!=null">
              <div class="col-md-12" (click)="Row_4_Img=null">
                <i class="fa fa-times remove-preview" aria-hidden="true"></i>
                <img src="assets/img/app-introduction/{{Row_4_Img}}.JPG" class="img-fluid figure-img rounded" />
              </div>
            </div>
          </div>
          <div class="steps-app-info">
            <i class="fa fa-circle pulsate" aria-hidden="true"></i>
            &nbsp;
            You can track orders, commission on products and view products invoices.
          </div>
          <div class="steps-app-info">
            <i class="fa fa-circle pulsate" aria-hidden="true"></i>
            &nbsp;
            Your customers can view your store using URL http://login.merchloop.com/your_store_url
            <br />
            *The URL of the store can be found on Edit option of store gallery or you can copy from Preview Store page.
          </div>
        </div>
      </div>
    </div>
  </div>
</main>



<!--<main class="main-wrap-ng">
  <div class="content-blk">
    <div class="container">
      <div class="dash-head" *ngIf="displayAlertConnectToPaypal">
        <h2 class="titleAlert">Alerts</h2>
      </div>
      <div class="alert alert-warning" *ngIf="displayAlertConnectToPaypal" role="alert">
        <a [routerLink]="['/store/adminaccount']">
          Please connect your Paypal account with MerchLoop so that there is no
          delay on processing your orders.
        </a>
      </div>
      <div class="add-product-container">
        <button class="pblsh-mat-btn add-product-btn"
                mat-raised-button
                (click)="showAddProductWindow()">
          Add Product
        </button>
      </div>
      <div class="row spc-25 dash-store-bx">

        <div class="col-lg-3 col-sm-6">

          <app-dashboard-count-sub-component color="ttl-od"
                                             service="none"
                                             [storeList]="storeList"
                                             title="Published Products"
                                             [count]="dashboardDivData.TotalNoOfPublishedProducts"
                                             [static]="true"
                                             labelClass="label-default"
                                             icon="shopping_cart"></app-dashboard-count-sub-component>
        </div>

        <div class="col-lg-3 col-sm-6">

          <app-dashboard-count-sub-component color="ttl-mn"
                                             service="none"
                                             [storeList]="storeList"
                                             title="Number of Stores"
                                             [count]="dashboardDivData.TotalNoOfStores"
                                             [static]="true"
                                             labelClass="label-pink"
                                             icon="store"></app-dashboard-count-sub-component>
        </div>

        <div class="col-lg-3 col-sm-6">
          <app-dashboard-count-sub-component color="ttl-store"
                                             service="GetTotalEndUsersOfStore"
                                             [storeList]="storeList"
                                             title="Users per store"
                                             icon="people_outline"></app-dashboard-count-sub-component>
        </div>
        <div class="col-lg-3 col-sm-6">
          <app-dashboard-count-sub-component color="earn-store"
                                             service="getStoreAdminEarningReportAp"
                                             [storeList]="storeList"
                                             title="Earning Per Store"
                                             icon="attach_money"
                                             [mapData]="earningPerStoreMap"
                                             [currency]="true"></app-dashboard-count-sub-component>
        </div>
      </div>

      <div class="row spc-25">
        <div class="col-lg-12"><app-line-chart></app-line-chart></div>
      </div>


      <div class="row">

        <div class="col-lg-4 col-sm-6">
          <app-dashboard-count-sub-component color="ttl-od dash-btm-gd dash-blue"
                                             service="getDailyVisitors"
                                             [storeList]="storeList"
                                             title="Daily Visitors"
                                             icon="access_alarm"
                                             labelClass="label-red"
                                             [topDesign]="false"></app-dashboard-count-sub-component>
        </div>

        <div class="col-lg-4 col-sm-6">
          <app-dashboard-count-sub-component color="ttl-od dash-btm-gd dash-lt-blue"
                                             service="getDesignViewedCount"
                                             [storeList]="storeList"
                                             title="Designs Viewed"
                                             icon="brush"
                                             labelClass="label-purple"
                                             [topDesign]="false"></app-dashboard-count-sub-component>

        </div>

        <div class="col-lg-4 col-sm-6">
          <app-dashboard-count-sub-component color="ttl-od dash-btm-gd dash-green"
                                             service="getOpenCartsQuery"
                                             [storeList]="storeList"
                                             title="Open Carts"
                                             icon="add_shopping_cart"
                                             labelClass="label-blue"
                                             [topDesign]="false"></app-dashboard-count-sub-component>
        </div>
      </div>

    </div>
  </div>
  <app-add-iframe-dispatch [login]="true"></app-add-iframe-dispatch>
</main>-->
